import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Rails from '@rails/ujs'
import React from 'react'

const TopHeader = styled.h4`
  margin-top: 0rem;
`

const CurrentQuestions = styled.div`
  max-width: 700px;
  max-height: 300px;
  overflow: auto;
  border-top: 1px solid gainsboro;
  border-bottom: 1px solid gainsboro;
`

const SearchQuestions = styled.div`
  max-width: 700px;
  max-height: 400px;
  overflow: auto;
  border-top: 1px solid gainsboro;
  border-bottom: 1px solid gainsboro;
`

const SearchBox = styled.div`
  max-width: 700px;
  margin-bottom: 1rem;
`

const QuestionRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border: solid 1px gainsboro;
  padding: 0.5rem;
`

const QuestionLabel = styled.div`
  font-weight: bold;
`

const QuestionText = styled.div`
  font-size: 80%;
`

const Button = styled.button`
  padding: 1rem;
  cursor: pointer;
  border: none;
  margin: 0;
  display: flex;
  background: transparent;

  ${props => props.disabled && css`
    opacity: .5;
    cursor: not-allowed;

    &:hover {
      opacity: .5;
    }
  `}
`

const Current = styled.span`
  color: gray;
  font-weight: normal;
  margin-left: 1em;
  font-size: 80%;
`

export default class BulkForm extends React.Component {
  timeout = null
  static propTypes = {
    pool_id: PropTypes.number.isRequired,
    questions: PropTypes.array.isRequired,
    pool_questions: PropTypes.array.isRequired,
    section_id: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)

    // How to set initial state in ES6 class syntax
    // https://reactjs.org/docs/state-and-lifecycle.html#adding-local-state-to-a-class
    this.state = {
      search: '',
      search_questions: props.questions,
      pool_questions: props.pool_questions,
      submitting: false
    }
  }

  searchChanged(newValue) {
    this.setState({ search: newValue })

    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.searchQuestions(newValue)
    }, 300)
  }

  searchQuestions(term) {
    let { section_id } = this.props

    fetch(`/sections/${section_id}/questions?questions_filter[search_term]=${encodeURIComponent(term)}]`, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken(),
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      redirect: 'follow',
      credentials: 'same-origin'
    })
      .then((res) => {
        return res.json()
      })
      .then((response) => {
        this.setState({ search_questions: response })
      })
  }

  addQuestion(question_id) {
    this.setState({ submitting: true })

    fetch('/pool_questions', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken(),
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      redirect: 'follow',
      credentials: 'same-origin',
      body: JSON.stringify({
        pool_question: {
          pool_id: this.props.pool_id,
          question_id: question_id
        }
      })
    })
      .then((res) => {
        return res.json()
      })
      .then((response) => {
        let newPoolQuestions = [...this.state.pool_questions]
        newPoolQuestions.push(response)

        this.setState({
          pool_questions: newPoolQuestions,
          submitting: false
        })
      })
  }

  removeQuestion(question_id) {
    let poolQuestion = this.onPool(question_id)

    this.setState({ submitting: true })

    fetch(`/pool_questions/${poolQuestion.id}`, {
      method: 'DELETE',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken(),
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      redirect: 'follow',
      credentials: 'same-origin'
    })
      .then((res) => {
        return res.json()
      })
      .then((response) => {
        let qIndex = this.state.pool_questions.findIndex((q_question) => {
          return q_question.id === response.id
        })

        if (qIndex >= 0) {
          let newPoolQuestions = [...this.state.pool_questions]
          newPoolQuestions.splice(qIndex, 1)

          this.setState({
            pool_questions: newPoolQuestions,
            submitting: false
          })
        }
      })
  }

  onPool(question_id) {
    return this.state.pool_questions.find((pool_question) =>{
      return pool_question.question_id === question_id
    })
  }

  render() {
    let { pool_id } = this.props

    let addButton = (question_id) => {
      return (
        <Button
          className="add-icon"
          onClick={() => { this.addQuestion(question_id)}}
          disabled={this.state.submitting}
        >
          <i className="fas fa-plus"></i>
        </Button>
      )
    }

    let removeButton = (question_id) => {
      return (
        <Button
          className="delete-icon"
          onClick={() => { this.removeQuestion(question_id)}}
          disabled={this.state.submitting}
        >
          <i className="fas fa-times"></i>
        </Button>
      )
    }

    let truncateQuestion = (str, num) => {
      if (str.length <= num) {
        return str
      }
      return str.slice(0, num) + '...'
    }

    let currentMarker = () => {
      return (
        <Current>Current pool question</Current>
      )
    }

    return (
      <div>
        <TopHeader>Current Pool Questions ({this.state.pool_questions.length})</TopHeader>
        <CurrentQuestions>
          {
            this.state.pool_questions.map((pool_question) => {
              return (
                <QuestionRow key={pool_question.id}>
                  <div>
                    <QuestionLabel>{ pool_question.question.label }</QuestionLabel>
                    <QuestionText>{ truncateQuestion(pool_question.question.question_text || '', 60) }</QuestionText>
                  </div>

                  { removeButton(pool_question.question.id) }
                </QuestionRow>
              )
            })
          }
        </CurrentQuestions>

        <h4>Search</h4>
        <SearchBox>
          <input type='text' value={this.state.search} onChange={(e) => { this.searchChanged(e.target.value) }} />
        </SearchBox>

        <h4>Available in Section</h4>
        <SearchQuestions>
          { this.state.search_questions.length === 0 ? 'No questions found.' : null }
          {
            this.state.search_questions.map((question) =>{
              let alreadyAttached = this.onPool(question.id)
              return (
                <QuestionRow key={question.id}>
                  <div>
                    <QuestionLabel>{ question.label }{ alreadyAttached ? currentMarker() : null }</QuestionLabel>
                    <QuestionText>{ truncateQuestion(question.question_text || '', 60) }</QuestionText>
                  </div>
                  {
                    alreadyAttached
                      ? (removeButton(question.id))
                      : null
                  }
                  {
                    !alreadyAttached
                      ? (addButton(question.id))
                      : null
                  }
                </QuestionRow>
              )
            })
          }
        </SearchQuestions>

      </div>
    )

  }
}
